import React, { useCallback, useEffect, type FC } from 'react'
import { Flex, ToastContainer, Tooltip } from 'mailup-web-components'
import Page from '../../containers/Page'
import Header from './components/Header'
import { useAtomCallback } from 'jotai/utils'
import { initPageCallback, resetPageCallback } from './callbacks/page'
import { useParams } from 'react-router-dom'
import { type Getter, type Setter } from 'jotai'
import InfoPanel from './components/InfoPanel'
import { CategoryForm } from '../newCategoriesListPage/components/CategoryForm'
import ConditionsPanel from './components/ConditionsPanel'
import SaveButton from './components/SaveButton'
import ModalGoToRecipients from './components/ModalGoToRecipients'

const CombinedFilterFormPage: FC = () => {
  const { id } = useParams()
  const Id = parseInt(id ?? '0')
  const initPage = useAtomCallback(
    useCallback(
      async (get: Getter, set: Setter) => {
        await initPageCallback(get, set, Id)
      },
      [Id],
    ),
  )
  const resetPage = useAtomCallback(resetPageCallback)

  useEffect(() => {
    void initPage()
    return resetPage
  }, [initPage, resetPage])

  return (
    <>
      <ModalGoToRecipients />
      <Header />
      <Page onReload={resetPage}>
        <ToastContainer />
        <Tooltip />
        <CategoryForm />
        <Flex flexDirection='column' gap='24px'>
          <InfoPanel />
          <ConditionsPanel />
          <Flex justifyContent='end'>
            <SaveButton />
          </Flex>
        </Flex>
      </Page>
    </>
  )
}

export default CombinedFilterFormPage
